import React from "react";
import classNames from "classnames/bind";

import styles from "./Ribbon.module.scss";
const cx = classNames.bind(styles);

const Ribbon = ({ label, isNew }) => {
  return (
    <div class={cx("ribbon", "ribbon-top-right", { "is-new": isNew })}>
      <span>{label}</span>
    </div>
  );
};

export default Ribbon;
